import { Typography } from '@mui/material'
import * as actions from '@returnmates/client-core/src/constants/actionTypes'
import { Trip } from '@returnmates/client-core/src/graphql/generated/api'
import { SnackBarStatuses } from '@returnmates/client-core/src/type'
import CopyIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/CopyIcon'
import OpenLinkIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/OpenLinkIcon'
import { WILSON_URL } from '@returnmates/ui-core/src/constants/paths'
import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import useStyles from '../styles'

interface Props {
  currentTrip: Trip | null
}

const Ids = ({ currentTrip }: Props) => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const copyToClipboard = useCallback(
    (id: string) => () => {
      navigator.clipboard.writeText(id || '')

      dispatch(
        actions.addSnackBar.request({
          type: SnackBarStatuses.SUCCESS,
          message: 'ID was successfully copied to the clipboard',
        }),
      )
    },
    [dispatch],
  )

  const openTrip = useCallback(() => {
    if (typeof window !== 'undefined') {
      const trackingLink = `${WILSON_URL}/trips?tripId=${currentTrip?.rescheduledTripId}`
      window.open(trackingLink, '_blank')?.focus()
    }
  }, [currentTrip?.rescheduledTripId])

  const openRoute = useCallback(() => {
    if (typeof window !== 'undefined') {
      const trackingLink = `${WILSON_URL}/routes?routeId=${currentTrip?.routeId}`
      window.open(trackingLink, '_blank')?.focus()
    }
  }, [currentTrip?.routeId])

  return (
    <div className={classes.idsContainer}>
      {currentTrip?.routeId ? (
        <div className={classes.detailsRow}>
          <div className={classes.selectWrapper}>
            <p className={classes.inputHead}>Route Id</p>
            <div className={classes.idContainer}>
              <Typography onClick={openRoute} className={classes.id}>
                {currentTrip?.routeId}
              </Typography>
              <div className={classes.idActions}>
                <CopyIcon onClick={copyToClipboard(currentTrip?.routeId || '')} />
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {currentTrip?.hasRescheduled && currentTrip?.currentId ? (
        <div className={classes.detailsRow}>
          <div className={classes.selectWrapper}>
            <p className={classes.inputHead}>Rescheduled Trip</p>
            <div className={classes.idContainer}>
              <Typography onClick={openTrip} className={classes.id}>
                {currentTrip.rescheduledTripId}
              </Typography>
              <div className={classes.idActions}>
                <OpenLinkIcon onClick={openTrip} />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default memo(Ids)
